module.exports = __webpack_public_path__ + "img/EDF.3c2c3ad2.png";